import application from 'application/application';

import templateUrl from './module-financial.template.html';

import controller from './module-financial.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider.state('root.default.module-financial', {
			url: '/financeiro',
			views: {
				'default@root.default': { templateUrl, controller }
			},
			data: {
				documentTitle: 'Financeiro'
			}
		});
	}
]);
